// Hero.jsx

import React from 'react';
import {
  FaArrowRight,
  FaPlayCircle
} from 'react-icons/fa';

import heroVideo from './assets/hero-bg.mp4';

function Hero() {

  return (
    <section className="hero" id="home">

      {/* BACKGROUND VIDEO */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="hero-video"
      >
        <source
          src={heroVideo}
          type="video/mp4"
        />
      </video>

      {/* DARK OVERLAY */}
      <div className="hero-overlay"></div>

      {/* CONTENT */}
      <div className="container hero-content">

        <div className="hero-text">

          <span className="tag">
            Smart Software. Real Business Growth.
          </span>

          <h1>
            Build Powerful Digital Solutions
            With Confidence
          </h1>

          <p>
            We design and develop modern software
            products that help businesses automate
            operations, serve customers better,
            and grow faster in the digital world.
          </p>

          <div className="hero-buttons">

            <a
              href="#contact"
              className="btn btn-primary"
            >
              Get Started
              <FaArrowRight />
            </a>

            <a
              href="#services"
              className="btn btn-secondary"
            >
              <FaPlayCircle />
              Explore Services
            </a>

          </div>
        </div>

        {/* RIGHT STATS */}

        <div className="hero-card">

          <div className="stat-box">
            <h3>50+</h3>
            <p>Projects Delivered</p>
          </div>

          <div className="stat-box">
            <h3>98%</h3>
            <p>Client Satisfaction</p>
          </div>

          <div className="stat-box">
            <h3>24/7</h3>
            <p>Support Available</p>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Hero;